import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

export default function AnnualIncomeDialog(props) {
  return (
      <Dialog open={props.open} onClose={props.onAnnualIncomeDialogClosed} scroll="body">
        <DialogContent className="product-info-dialog-content">
          <IconButton className="product-info-close-button" aria-label="close" onClick={props.onAnnualIncomeDialogClosed}>
            <CloseIcon />
          </IconButton>

          <h4>Annual Income</h4>
          <p>The minimum annual income supported is $18,000</p>

          <p>Annual income includes salary, bonuses, commissions and other monetary compensation (net of expenses for business owners and self-employed individuals).</p>
        </DialogContent>
      </Dialog>
  );
}

AnnualIncomeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onAnnualIncomeDialogClosed: PropTypes.func.isRequired,
};




// WEBPACK FOOTER //
// ./src/components/Quoters/Ameritas/Helpers/AnnualIncomeDialog.js